// Sync the mobile filter drawer's "active filters + Remove all" block after
// every ajax filter update. Load with defer next to collection-filter-drawer.js
// so path-based tag URLs apply before any filter interaction.
//
// Design constraints (lessons learned the hard way):
//  - Do NOT wrap or replace window.fetch (browser body-lock can stall the
//    theme's own renderProductGrid -> renderFilters chain, which in turn
//    blocks history.pushState, which then makes "URL doesn't change").
//  - Do NOT touch any CollectionFilters / WAU.Slideout members.
//  - Listen passively for the grid replacement that the theme already does,
//    then issue our own independent fetch to read just the drawer slice.
(function () {
  if (window.__drawerActiveFiltersSyncV2) return;
  window.__drawerActiveFiltersSyncV2 = true;
  // collection-filter-sync owns desktop filter change delegation; skip the
  // duplicate listener at the bottom of section-main-collection.js.
  window.__desktopFilterDelegationBound = true;

  var DRAWER_SEL = '#slideout-collection-filters .filter-drawer__menu-block[data-menu-handle="filter"]';
  var ACTIVE_SEL = '.filter-drawer__active-filters';

  function getCollectionUrl() {
    var node = document.querySelector('[data-section-type="collection"][data-collection-url]')
      || document.querySelector('[data-collection-url]');
    return (node && node.getAttribute('data-collection-url')) || '';
  }

  // Shopify's Liquid collection.url often includes the current tag path when
  // already filtered (e.g. /collections/dresses/lace). Appending another
  // /tag would produce /dresses/lace/lace and return zero products — always
  // strip back to /.../collections/<handle> using the known handle.
  function getCollectionBasePathFromPath(path) {
    var section = document.querySelector('[data-section-type="collection"][data-collection-handle]');
    var handle = section && section.getAttribute('data-collection-handle');
    var pathClean = (path || window.location.pathname || '').split('?')[0].replace(/\/+$/, '');
    if (handle) {
      var esc = handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = new RegExp('^(.*/collections/' + esc + ')(?:/.+)?$');
      var m = pathClean.match(re);
      if (m) return m[1].replace(/\/+$/, '');
    }
    var attr = getCollectionUrl();
    if (attr) {
      try {
        var abs = attr.indexOf('//') >= 0 ? attr : (window.location.origin + (attr.charAt(0) === '/' ? '' : '/') + attr);
        return new URL(abs).pathname.replace(/\/+$/, '');
      } catch (_) {
        return String(attr).split('?')[0].replace(/\/+$/, '');
      }
    }
    return pathClean || '/';
  }

  function getCollectionBasePath() {
    return getCollectionBasePathFromPath(window.location.pathname);
  }

  function handleizeTag(tag) {
    return String(tag == null ? '' : tag).toLowerCase().trim()
      .replace(/[^\w\u00a1-\uffff]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function extractTagsFromPath(pathname) {
    if (!pathname) return [];
    var norm = String(pathname).split('?')[0].replace(/\/+$/, '');
    var base = getCollectionBasePathFromPath(norm);
    if (!base) return [];
    var prefix = base + '/';
    if (norm.indexOf(prefix) !== 0) return [];
    var tagPart = norm.substring(prefix.length);
    if (!tagPart) return [];
    return tagPart.split('+').filter(Boolean);
  }

  var DEFAULT_SORT_BY = 'manual';

  function stripRedundantSortBy(params) {
    try {
      if (!params || typeof params.get !== 'function' || typeof params.delete !== 'function') return;
      var v = params.get('sort_by');
      if (v == null || String(v).trim() === '') {
        params.delete('sort_by');
        return;
      }
      if (String(v).toLowerCase() === DEFAULT_SORT_BY) {
        params.delete('sort_by');
      }
    } catch (_) { /* no-op */ }
  }

  // Patch CollectionFilters.renderPage so that any filter.p.tag values in the
  // query string get rewritten to Shopify's traditional path-based tag URL
  // (/collections/<handle>/<tag>+<tag>). This works without the Search &
  // Discovery app and without any admin filter configuration.
  function patchRenderPage() {
    if (!window.CollectionFilters || typeof window.CollectionFilters.renderPage !== 'function') {
      setTimeout(patchRenderPage, 50);
      return;
    }
    if (window.CollectionFilters.__patchedForTagPath) return;
    window.CollectionFilters.__patchedForTagPath = true;

    var origRenderPage = window.CollectionFilters.renderPage;
    var renderCoalescePending = null;
    var renderCoalesceScheduled = false;

    function runPatchedRenderPage(qs, updateUrl) {
      if (updateUrl === undefined) updateUrl = true;
      var params;
      try { params = new URLSearchParams(qs || ''); } catch (_) { params = new URLSearchParams(); }
      var rawTagValues = params.getAll('filter.p.tag');
      while (params.has('filter.p.tag')) params.delete('filter.p.tag');
      var seen = {};
      var tagSlugs = [];
      rawTagValues.forEach(function (v) {
        var slug = handleizeTag(v);
        if (slug && !seen[slug]) { seen[slug] = true; tagSlugs.push(slug); }
      });
      stripRedundantSortBy(params);
      var tagSuffix = tagSlugs.length ? '/' + tagSlugs.join('+') : '';
      var newPath = getCollectionBasePath() + tagSuffix;
      var otherQs = params.toString();
      var newUrl = newPath + (otherQs ? '?' + otherQs : '');
      try {
        if (updateUrl) {
          history.pushState({ searchParams: otherQs }, '', newUrl);
        } else {
          history.replaceState({ searchParams: otherQs }, '', newUrl);
        }
      } catch (_) { /* no-op */ }
      scheduleGridSync();
      try { syncCheckboxesFromUrl(); } catch (_) { /* no-op */ }
      return origRenderPage.call(window.CollectionFilters, otherQs, false);
    }

    window.CollectionFilters.renderPage = function (qs, updateUrl) {
      renderCoalescePending = { qs: qs, updateUrl: updateUrl };
      if (renderCoalesceScheduled) return;
      renderCoalesceScheduled = true;
      queueMicrotask(function () {
        renderCoalesceScheduled = false;
        var pending = renderCoalescePending;
        renderCoalescePending = null;
        if (!pending) return;
        runPatchedRenderPage(pending.qs, pending.updateUrl);
      });
    };

    patchFilterListenerAccumulation();
  }

  // renderFilters() re-runs drawerFilters/currentFilters after every AJAX
  // grid refresh; without a guard each filter click stacks another listener
  // and can blow the call stack (Maximum call stack size exceeded).
  function patchFilterListenerAccumulation() {
    if (!window.CollectionFilters || window.CollectionFilters.__joyFilterBindGuard) return;
    window.CollectionFilters.__joyFilterBindGuard = true;

    var origDrawer = window.CollectionFilters.drawerFilters;
    if (typeof origDrawer === 'function') {
      window.CollectionFilters.drawerFilters = function () {
        document.querySelectorAll('.js-filter').forEach(function (el) {
          if (el.dataset.joyDrawerFilterBound === '1') return;
          el.dataset.joyDrawerFilterBound = '1';
          el.addEventListener('click', function (ev) {
            ev.preventDefault();
            var cb = el.querySelector('input[type="checkbox"]');
            if (!cb) return;
            if (cb.checked) {
              el.classList.remove('current');
              cb.checked = false;
            } else {
              el.classList.add('current');
              cb.checked = true;
            }
            var form = el.closest('form');
            var params = new URLSearchParams(form ? new FormData(form) : '');
            window.CollectionFilters.renderPage(params.toString());
          });
        });
      };
    }

    var origCurrent = window.CollectionFilters.currentFilters;
    if (typeof origCurrent === 'function') {
      window.CollectionFilters.currentFilters = function () {
        document.querySelectorAll('.js-current-filter').forEach(function (el) {
          if (el.dataset.joyCurrentFilterBound === '1') return;
          el.dataset.joyCurrentFilterBound = '1';
          el.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (window.CollectionFilters && typeof window.CollectionFilters.onActiveFilterClick === 'function') {
              window.CollectionFilters.onActiveFilterClick(ev);
            }
          });
        });
      };
    }
  }

  patchRenderPage();

  // Re-sync active filters every time the mobile filter drawer opens,
  // covering the case where the user filtered before opening the drawer
  // (or the MutationObserver missed the grid replacement).
  try {
    if (window.Events && typeof window.Events.on === 'function') {
      window.Events.on('slideout:open:collection-filters', function () {
        syncActiveFilters();
        syncCheckboxesFromUrl();
      });
    }
  } catch (_) { /* no-op */ }

  // Desktop FILTER: capture + stopImmediatePropagation avoids double-toggle with
  // theme init; delegation survives AJAX grid replace (removed inline onclick).
  document.addEventListener('click', function (ev) {
    if (window.innerWidth < 1024) return;
    var t = ev.target;
    if (!t || typeof t.closest !== 'function') return;
    var btn = t.closest(
      '#collection-page .js-filter-toggle.js-slideout-open[data-wau-slideout-target="collection-filters"]'
    );
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    var panel = document.getElementById('desktop-filter-panel');
    var dd = document.getElementById('desktop-filter-dropdown');
    if (panel && dd) {
      panel.classList.toggle('active');
      dd.classList.toggle('active');
    }
  }, true);

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || typeof t.closest !== 'function') return;
    if (!t.closest('.js-filter-toggle.js-slideout-open')) return;
    // Defer one frame so the drawer DOM is in the open state first.
    setTimeout(function () {
      syncActiveFilters();
      syncCheckboxesFromUrl();
    }, 30);
  });

  function getSectionId() {
    var grid = document.getElementById('main-collection-product-grid');
    return grid && grid.dataset ? grid.dataset.id : null;
  }

  function buildSectionUrl() {
    var sid = getSectionId();
    if (!sid) return null;
    var search = window.location.search || '';
    var glue = search ? '&' : '';
    return window.location.pathname + '?section_id=' + encodeURIComponent(sid)
      + glue + (search.charAt(0) === '?' ? search.slice(1) : search);
  }

  function applyHtml(html) {
    try {
      if (typeof html !== 'string') return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var menuBlock = document.querySelector(DRAWER_SEL);
      if (!menuBlock) return;
      var fetchedMenu = doc.querySelector('.filter-drawer__menu-block[data-menu-handle="filter"]');
      if (!fetchedMenu) return;
      var newBlock = fetchedMenu.querySelector(ACTIVE_SEL);
      var existing = menuBlock.querySelector(ACTIVE_SEL);
      if (newBlock) {
        if (existing) {
          existing.innerHTML = newBlock.innerHTML;
        } else {
          menuBlock.insertBefore(newBlock, menuBlock.firstElementChild);
        }
      } else if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    } catch (_) { /* never throw */ }
  }

  var pendingUrl = null;
  var syncChainDepth = 0;
  var MAX_SYNC_CHAIN = 5;
  var gridSyncTimer = null;

  function syncActiveFilters() {
    var url = buildSectionUrl();
    if (!url) return;
    if (syncChainDepth >= MAX_SYNC_CHAIN) return;
    // If a fetch for the *same* URL is already in-flight, don't duplicate.
    // Otherwise allow re-issuing (URL changed between rapid clicks).
    if (pendingUrl === url) return;
    pendingUrl = url;
    syncChainDepth++;
    try {
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res && res.ok ? res.text() : ''; })
        .then(function (html) {
          applyHtml(html);
          // If the URL drifted while we were fetching, kick off another
          // sync so the drawer ends up consistent with the latest path.
          var latest = buildSectionUrl();
          pendingUrl = null;
          syncChainDepth--;
          if (latest && latest !== url && syncChainDepth < MAX_SYNC_CHAIN) {
            syncActiveFilters();
          }
        })
        .catch(function () {
          pendingUrl = null;
          syncChainDepth = Math.max(0, syncChainDepth - 1);
        });
    } catch (_) {
      pendingUrl = null;
      syncChainDepth = Math.max(0, syncChainDepth - 1);
    }
  }

  function syncCcfsActiveStates() {
    document.querySelectorAll('[data-ccfs-root] .js-ccfs-filter').forEach(function (btn) {
      var param = btn.getAttribute('data-filter-param');
      if (!param) {
        var root = btn.closest('[data-ccfs-root]');
        if (root) param = root.getAttribute('data-ccfs-filter-param');
      }
      if (!param) return;
      var val = btn.getAttribute('data-filter-value');
      var on = false;
      document.querySelectorAll(
        '#CollectionFiltersForm input[name], [form="CollectionFiltersForm"] input[name]'
      ).forEach(function (input) {
        if (input.name === param && String(input.value) === String(val) && input.checked) on = true;
      });
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function scheduleGridSync() {
    if (gridSyncTimer) clearTimeout(gridSyncTimer);
    gridSyncTimer = setTimeout(function () {
      gridSyncTimer = null;
      syncActiveFilters();
      syncCheckboxesFromUrl();
      syncCcfsActiveStates();
    }, 50);
  }

  function syncCheckboxesFromUrl() {
    try {
      var activeSlugs = extractTagsFromPath(window.location.pathname);
      document.querySelectorAll('input[name="filter.p.tag"]').forEach(function (input) {
        input.checked = activeSlugs.indexOf(handleizeTag(input.value)) !== -1;
      });
    } catch (_) { /* no-op */ }
  }

  function bindGridObserver() {
    var grid = document.getElementById('CollectionProductGrid');
    if (!grid || grid.__drawerSyncObserved) return;
    grid.__drawerSyncObserved = true;
    try {
      var obs = new MutationObserver(function (mutations) {
        if (!mutations || !mutations.length) return;
        var changed = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'childList') { changed = true; break; }
        }
        if (changed) scheduleGridSync();
      });
      obs.observe(grid, { childList: true });
    } catch (_) { /* MutationObserver missing -> no-op */ }
    syncCheckboxesFromUrl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGridObserver);
  } else {
    bindGridObserver();
  }

  // Convert any URL (path-based tag URL or query-only URL) back into a
  // query string of params + filter.p.tag values, suitable for feeding into
  // the patched CollectionFilters.renderPage.
  function urlToParams(url) {
    var params;
    try {
      var u = new URL(url, window.location.origin);
      params = u.searchParams;
      var pathTags = extractTagsFromPath(u.pathname);
      pathTags.forEach(function (slug) { params.append('filter.p.tag', slug); });
    } catch (_) {
      params = new URLSearchParams();
    }
    stripRedundantSortBy(params);
    return params;
  }

  // Click delegation for active-filter chips (× on tags + Remove all).
  // Covers both the desktop inline chips (.active-filters-inline a, .clear-all-link)
  // and the mobile drawer chips (.filter-drawer__active-filters a).
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest(
      '.active-filters-inline a,'
      + ' .clear-all-link,'
      + ' #slideout-collection-filters ' + ACTIVE_SEL + ' a'
    );
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (!href) return;
    if (!window.CollectionFilters || typeof window.CollectionFilters.renderPage !== 'function') {
      return; // fall back to native navigation
    }
    ev.preventDefault();
    var params = urlToParams(href);
    window.CollectionFilters.renderPage(params.toString());
  });

  // Build the full URLSearchParams from the unified collection-filter form.
  // Query explicit selectors instead of relying only on HTMLFormElement.elements:
  // some engines under-include controls associated via form="CollectionFiltersForm"
  // when they live outside the <form> node (desktop tag checkboxes + sort select).
  function collectFormParams() {
    var form = document.getElementById('CollectionFiltersForm');
    var params = new URLSearchParams();
    var seenTag = {};
    if (!form) return params;

    var els = document.querySelectorAll(
      '#CollectionFiltersForm input, #CollectionFiltersForm select, #CollectionFiltersForm textarea, ' +
      '[form="CollectionFiltersForm"]'
    );

    var i, el, len, tag, type, slug, val;
    for (i = 0, len = els.length; i < len; i++) {
      el = els[i];
      if (!el || !el.name || el.disabled) continue;
      tag = el.tagName ? el.tagName.toLowerCase() : '';

      if (tag === 'select') {
        if (el.value === '' || el.value == null) continue;
        if (el.name === 'sort_by' && String(el.value).toLowerCase() === DEFAULT_SORT_BY) continue;
        params.append(el.name, el.value);
        continue;
      }

      if (tag === 'input') {
        type = (el.type || '').toLowerCase();
        if (type === 'checkbox' || type === 'radio') {
          if (!el.checked) continue;
          val = el.value;
          if (val === '' || val == null) val = 'on';
          if (el.name === 'filter.p.tag') {
            slug = handleizeTag(val);
            if (!slug || seenTag[slug]) continue;
            seenTag[slug] = true;
            params.append('filter.p.tag', val);
          } else {
            params.append(el.name, val);
          }
          continue;
        }
        if (type === 'hidden' || type === 'text' || type === 'search' ||
            type === 'number' || type === 'range') {
          if (el.value !== '' && el.value != null) params.append(el.name, el.value);
        }
        continue;
      }

      if (tag === 'textarea' && el.value !== '' && el.value != null) {
        params.append(el.name, el.value);
      }
    }

    return params;
  }

  window.__collectCollectionFilterParams = collectFormParams;

  /** Avoid querySelector('[value="..."]'): tag labels with ] \ etc. throw and block filter AJAX. */
  function syncDesktopTagTwinFromMobile(mobileInput) {
    if (!mobileInput || mobileInput.name !== 'filter.p.tag') return;
    var panel = document.getElementById('desktop-filter-panel');
    if (!panel) return;
    var want = mobileInput.value;
    try {
      var inputs = panel.querySelectorAll('input[name="filter.p.tag"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === want) {
          inputs[i].checked = mobileInput.checked;
          return;
        }
      }
    } catch (_) { /* no-op */ }
  }

  function dispatchRenderPage(params) {
    if (window.CollectionFilters && typeof window.CollectionFilters.renderPage === 'function') {
      window.CollectionFilters.renderPage(params.toString(), true);
      return;
    }
    var fallbackTags = [];
    var fallbackOther = new URLSearchParams();
    params.forEach(function (v, k) {
      if (k === 'filter.p.tag') {
        var slug = handleizeTag(v);
        if (slug && fallbackTags.indexOf(slug) === -1) fallbackTags.push(slug);
      } else {
        fallbackOther.append(k, v);
      }
    });
    stripRedundantSortBy(fallbackOther);
    var qs = fallbackOther.toString();
    var path = getCollectionBasePath() + (fallbackTags.length ? '/' + fallbackTags.join('+') : '');
    window.location.assign(path + (qs ? '?' + qs : ''));
  }

  // Sort dropdown: avoid this.form.submit() — programmatic submit() bypasses the
  // submit event and can desync from the same AJAX + path-based tag URL path as filters.
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || typeof t.matches !== 'function') return;
    if (!t.matches('select.sort-select[name="sort_by"]')) return;
    dispatchRenderPage(collectFormParams());
  });

  // Desktop filter change delegation. Survives every ajax re-render because
  // it binds at document level, not on individual inputs (which are
  // replaced when CollectionFilters.renderProductGrid wipes the grid HTML).
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || typeof t.matches !== 'function') return;
    if (!t.matches('#desktop-filter-panel input[type="checkbox"], #desktop-filter-panel input[type="radio"]')) return;
    dispatchRenderPage(collectFormParams());
  });

  // Mobile drawer: native checkbox toggle fires `change`. (Programmatic
  // `.checked = ...` from the row/label path does not — that path still
  // dispatches from the capture click handler below.)
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || t.nodeName !== 'INPUT' || String(t.type).toLowerCase() !== 'checkbox') return;
    var item = t.closest && t.closest('.slide-nav__second-level--item.js-filter');
    if (!item) return;
    var drawer = document.getElementById('slideout-collection-filters');
    if (!drawer || !drawer.contains(item)) return;
    syncDesktopTagTwinFromMobile(t);
    item.classList.toggle('current', t.checked);
    dispatchRenderPage(collectFormParams());
  });

  /** Stop click bubbling from checkbox → li so theme drawerFilters does not double-toggle. */
  function bindMobileDrawerFilterCheckboxBubbleGuard() {
    var drawer = document.getElementById('slideout-collection-filters');
    if (!drawer) return;
    drawer.querySelectorAll('.slide-nav__second-level--item.js-filter input[type="checkbox"]').forEach(function (cb) {
      if (cb.dataset.joyFilterCheckboxBubbleGuard === '1') return;
      cb.dataset.joyFilterCheckboxBubbleGuard = '1';
      cb.addEventListener(
        'click',
        function (ev) {
          ev.stopPropagation();
        },
        false
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMobileDrawerFilterCheckboxBubbleGuard);
  } else {
    bindMobileDrawerFilterCheckboxBubbleGuard();
  }
  document.addEventListener('shopify:section:load', bindMobileDrawerFilterCheckboxBubbleGuard);

  // Mobile price apply button delegation. Theme legacy code only checks
  // `event.target.matches('.js-update-price')`, so clicking the nested
  // <span> label may fail to trigger. Use closest() to make it robust.
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || typeof t.closest !== 'function') return;
    var drawer = t.closest('#slideout-collection-filters');
    if (!drawer) return;
    var btn = t.closest('.js-update-price');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    dispatchRenderPage(collectFormParams());
  }, true);

  // Mobile drawer click delegation: taps on the row (text passes through
  // pointer-events:none links and hit the li) toggle programmatically.
  // Direct taps on the checkbox must skip this capture handler so the event
  // reaches the input (native toggle + change); checkbox bubble is stopped
  // in bindMobileDrawerFilterCheckboxBubbleGuard so theme drawerFilters
  // does not invert state again.
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || typeof t.closest !== 'function') return;
    var drawer = t.closest('#slideout-collection-filters');
    if (!drawer) return;
    var item = t.closest('.slide-nav__second-level--item.js-filter');
    if (!item) return;
    var input = item.querySelector('input[type="checkbox"]');
    if (!input) return;
    if (t.matches && t.matches('input[type="checkbox"]')) {
      return;
    }
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    input.checked = !input.checked;
    item.classList.toggle('current', input.checked);
    syncDesktopTagTwinFromMobile(input);
    dispatchRenderPage(collectFormParams());
  }, true);

  // Collection color filter swatches (collection-color-filter-swatches.liquid)
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-ccfs-root] .js-ccfs-filter') : null;
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var param = btn.getAttribute('data-filter-param');
    if (!param) {
      var root = btn.closest('[data-ccfs-root]');
      if (root) param = root.getAttribute('data-ccfs-filter-param');
    }
    if (!param) return;
    var val = btn.getAttribute('data-filter-value');
    var next = null;
    document.querySelectorAll(
      '#CollectionFiltersForm input[name], [form="CollectionFiltersForm"] input[name]'
    ).forEach(function (input) {
      if (input.name !== param || String(input.value) !== String(val)) return;
      if (next === null) next = !input.checked;
      input.checked = next;
      var row = input.closest('.slide-nav__second-level--item.js-filter');
      if (row) row.classList.toggle('current', next);
    });
    syncCcfsActiveStates();
    dispatchRenderPage(collectFormParams());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCcfsActiveStates);
  } else {
    syncCcfsActiveStates();
  }
  document.addEventListener('shopify:section:load', syncCcfsActiveStates);
})();
